import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { LineItemUpsell } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { useSessionStorage } from "@grandvisionhq/utils";
import { useAddToCart } from "../../../../../../hooks/hooks/use-add-to-cart.js";
import { useCartSettings } from "../../../../../../context/CartSettings/context/CartSettings/context.js";
const Insurance = ({ visualLineItem, handleOpenModal }) => {
  const intl = useIntl();
  const settings = useCartSettings();
  const [addToCart] = useAddToCart();
  const [consent, setConsent] = useSessionStorage(
    `insurance_terms_and_conditions-${visualLineItem.id}`,
    void 0,
    (value) => !value
  );
  const insuranceLabels = React.useMemo(
    () => ({
      add: intl.getLabel("common.add"),
      free: intl.getLabel("common.free"),
      title: intl.getLabel("cart.insurance.title"),
      consent: intl.getLabel("cart.insurance.consent.conditions"),
      uspList: [
        intl.getLabel("cart.insurance.usp1", { hideLabelKey: true }),
        intl.getLabel("cart.insurance.usp2", { hideLabelKey: true })
      ].filter(Boolean),
      moreAbout: intl.getLabel("cart.insurance.moreAboutCoverage"),
      implicitTermsAndAgreementLabel: intl.getFormattedLabel(
        "cart.insurance.implicitTermsAndAgreementLabel",
        {
          parseLink: true,
          openLinksInNewTab: true
        }
      ),
      explicitTermsAndAgreementLabel: intl.getFormattedLabel(
        "cart.insurance.explicitTermsAndAgreementLabel",
        {
          parseLink: true,
          openLinksInNewTab: true
        }
      ),
      errorMessage: intl.getLabel("common.form.field.requiredError")
    }),
    [intl]
  );
  if (!visualLineItem.eligibleInsurance) {
    return null;
  }
  const onError = (errorCodes) => errorCodes.forEach((code) => toast.failed(`cart.${code}`));
  const handleAddToCart = () => {
    const { eligibleInsurance } = visualLineItem;
    if (!eligibleInsurance) {
      return;
    }
    const itemDraft = {
      sku: eligibleInsurance.sku,
      quantity: 1,
      type: "insurance",
      typeDetails: {
        lineItemId: visualLineItem.id
      }
    };
    addToCart([itemDraft], void 0, onError, (e) => onError([e]));
  };
  const handleTermsAndConditionsChange = (checked) => {
    setConsent(checked);
  };
  const analyticsData = {
    button: {
      dataElementId: "Prods_AddWarranty",
      dataDescription: "Protection Plan"
    }
  };
  return /* @__PURE__ */ React.createElement(
    LineItemUpsell,
    {
      sku: visualLineItem.eligibleInsurance.sku,
      labels: insuranceLabels,
      currency: intl.currency,
      value: visualLineItem.eligibleInsurance.price.subtotal,
      hasImplicitTermsAndConditions: settings.shouldShowInsuranceImplicitTermsAndConditions,
      handleOpenModal,
      handleAddToCart,
      onTermsAndConditionsChange: handleTermsAndConditionsChange,
      isChecked: consent,
      errorMessageKey: "cart.insurance.error.required",
      analyticsData
    }
  );
};
export {
  Insurance
};
//# sourceMappingURL=Insurance.js.map
